/* istanbul ignore file */
import { boolean as codecBoolean, optional as codecOptional } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { WebhookConfigurationDisabledAsJSON } from './WebhookConfigurationDisabledAsJSON';
import { WebhookConfigurationEnabledAsJSON } from './WebhookConfigurationEnabledAsJSON';
const JsonPatchSubmitTypesAssignmentParser = 
/* #__PURE__ */ parsers.object([
    [
        'filesUploadEnabled',
        /* #__PURE__ */ codecOptional(codecBoolean),
        'files_upload_enabled',
    ],
    [
        'webhookUploadEnabled',
        /* #__PURE__ */ codecOptional(codecBoolean),
        'webhook_upload_enabled',
    ],
    [
        'webhookConfiguration',
        /* #__PURE__ */ codecOptional(
        /* #__PURE__ */ parsers.taggedUnion('tag', [
            ['enabled', WebhookConfigurationEnabledAsJSON],
            ['disabled', WebhookConfigurationDisabledAsJSON],
        ])),
        'webhook_configuration',
    ],
    [
        'editorUploadEnabled',
        /* #__PURE__ */ codecOptional(codecBoolean),
        'editor_upload_enabled',
    ],
]);
export class JsonPatchSubmitTypesAssignment extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return JsonPatchSubmitTypesAssignmentParser.decode(input).map(res => new JsonPatchSubmitTypesAssignment(res));
    }
    static unsafeDecode(input) {
        return JsonPatchSubmitTypesAssignment.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return JsonPatchSubmitTypesAssignmentParser.encode(data);
    }
    static schema() {
        return JsonPatchSubmitTypesAssignmentParser.schema();
    }
}
